import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["color"];
import React, { memo } from 'react';
const RolesIcon = _ref => {
  let {
      color = '#335B70'
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 32 32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M17.374 7.7c-0.193-4.367-3.526-7.503-7.596-7.503-4.193 0-7.605 3.329-7.605 7.903v2.37h-1.63l-0.125 0.016c-0.24 0.061-0.419 0.296-0.419 0.577v14.814l0.011 0.242c0.111 1.194 1.038 2.128 2.162 2.128l13.827-0.002v-9.331c0-0.987 0.642-1.874 1.58-2.14v-0.082c0-2.101 0.747-4.032 1.976-5.47l-0.001-0.159-0.014-0.136c-0.056-0.262-0.271-0.457-0.529-0.457h-1.63v-2.37l-0.009-0.4zM5.432 8.1c0-2.614 1.949-4.741 4.346-4.741s4.346 2.127 4.346 4.741v2.37h-8.691v-2.37zM30.419 16.692v1.778h1.185c0.218 0 0.395 0.199 0.395 0.444v11.111c0 0.98-0.709 1.778-1.58 1.778h-11.061c-0.872 0-1.58-0.797-1.58-1.778v-11.111c0-0.246 0.177-0.444 0.395-0.444h1.185v-1.778c0-3.431 2.481-5.904 5.531-5.904s5.531 2.473 5.531 5.904zM21.728 16.692v1.778h6.321v-1.778c0-1.96-1.418-3.555-3.16-3.555s-3.16 1.595-3.16 3.555z"
  }));
};
export default /*#__PURE__*/memo(RolesIcon);